/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


          		
              // Map your choices to your option value
          /*    var lookup = {
                 'Option 1': ['CALIFORNIA', 'ALABAMA', 'AIRIZONA ' ],
                 'Option 2': ['OSAKA'],
                 
              };

              // When an option is changed, search the above for matching choices
              $('#options').on('change', function() {
                 // Set selected option as variable
                 var selectValue = $(this).val();

                 // Empty the target field
                 $('#choices').empty();

                 // For each chocie in the selected option
                 for (i = 0; i < lookup[selectValue].length; i++) {
                    // Output choice in the target field
                    $('#choices').append("<option value='" + lookup[selectValue][i] + "'>" + lookup[selectValue][i] + "</option>");
                 }
              });*/
//hides dropdown content
  $(".state_locate").hide();
  
//unhides first option content
  $("#option3").show();

$("#usa_state").change(function(){
    //rehide content on change
    $('.state_locate').hide();
    //unhides current item
    $('#'+$(this).val()).show();
  });

$(".state_select").hide();

$("#usa_state").show();

$("#country_select").change(function(){
  $('.state_locate').hide();
  $(".state_select").hide();
  $('.state_select').trigger( "click" );
  $('#'+$(this).val()).show();
  $("#jp-option1").toggle().show();
});